import FuseScrollbars from '@fuse/core/FuseScrollbars';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import React, { useRef } from 'react';
import useGetPageSection from 'app/hooks/useGetPageSection';
import FusePageSimpleHeader from './FusePageSimpleHeader';
import FusePageSimpleSidebar from './FusePageSimpleSidebar';

type Props = {
	leftSidebarHeader?: React.ReactNode;
	leftSidebarContent?: React.ReactNode;
	leftSidebarVariant?: React.ReactNode;
	rightSidebarHeader?: React.ReactNode;
	rightSidebarContent?: React.ReactNode;
	rightSidebarVariant?: React.ReactNode;
	header?: React.ReactNode;
	content?: React.ReactNode;
	contentToolbar?: React.ReactNode;
	sidebarInner?: boolean;
	innerScroll?: boolean;
	classes?: { [key: string]: any };
};

const headerHeight = 120;
const toolbarHeight = 64;
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		minHeight: 'calc(100vh - 115px)', // '100%',
		position: 'relative',
		flex: '1 0 auto',
		height: 'auto',
	},
	innerScroll: {
		flex: '1 1 auto',
		height: '100%',
	},
	wrapper: {
		display: 'flex',
		flexDirection: 'row',
		flex: '1 1 auto',
		zIndex: 2,
		maxWidth: '100%',
		minWidth: 0,
		height: '100%',
	},
	header: {
		height: headerHeight,
		minHeight: headerHeight,
		display: 'flex',
		// background: `linear-gradient(to right, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
		// color: theme.palette.primary.contrastText
		// backgroundSize: 'cover',
		// backgroundColor: theme.palette.primary.dark,
	},
	topBg: {
		position: 'absolute',
		left: 0,
		right: 0,
		top: 0,
		height: headerHeight,
		pointerEvents: 'none',
	},
	/* contentCardWrapper            : {
         display : 'flex ',
         flex    : '1 1 auto',
         overflow: 'visible!important',
         minWidth: 0,
         '&.ps'  : {
             overflow: 'visible!important'
         }
     },
     contentCardWrapperInnerSidebar: {
         display                     : 'block',
         overflow                    : 'auto!important',
         '-webkit-overflow-scrolling': 'touch',
         '&.ps'                      : {
             overflow: 'hidden!important'
         },
         '& $contentCard'            : {
             borderRadius: 8
         }
     }, */
	contentWrapper: {
		display: 'flex',
		flexDirection: 'column',
		flex: '1 1 auto',
		overflow: 'auto',
		overflowX: 'hidden',
		'-webkit-overflow-scrolling': 'touch',
		zIndex: 9999,
	},
	toolbar: {
		height: toolbarHeight,
		minHeight: toolbarHeight,
		display: 'flex',
		alignItems: 'center',
	},
	content: {
		display: 'flex',
		flex: '1 0 auto',
		paddingLeft: '2.4rem',
		paddingRight: '2.4rem',
		paddingBottom: '3.6rem',
	},
	sidebarWrapper: {
		overflow: 'hidden',
		backgroundColor: 'transparent',
		position: 'absolute',
		'&.permanent': {
			[theme.breakpoints.up('lg')]: {
				position: 'relative',
			},
		},
	},
	sidebar: {
		position: 'absolute',
		'&.permanent': {
			[theme.breakpoints.up('lg')]: {
				backgroundColor: theme.palette.background.default,
				color: theme.palette.text.primary,
				position: 'relative',
			},
		},
		width: drawerWidth,
		height: '100%',
	},
	leftSidebar: {
		[theme.breakpoints.up('lg')]: {
			borderRight: `1px solid ${theme.palette.divider}`,
			borderLeft: 0,
		},
	},
	rightSidebar: {
		[theme.breakpoints.up('lg')]: {
			borderLeft: `1px solid ${theme.palette.divider}`,
			borderRight: 0,
		},
	},
	sidebarHeader: {
		height: headerHeight,
		minHeight: headerHeight,
		backgroundColor: theme.palette.primary.dark,
		color: theme.palette.primary.contrastText,
	},
	sidebarHeaderInnerSidebar: {
		backgroundColor: 'transparent',
		color: 'inherit',
		height: 'auto',
		minHeight: 'auto',
	},
	sidebarContent: {},
	backdrop: {
		position: 'absolute',
	},
}));

type SidebarRef = HTMLElement & { toggleSidebar: () => void };

const FusePageSimple = React.forwardRef((props: Props, ref) => {
	// console.info("render::FusePageSimple");
	const pageSection = useGetPageSection();
	const leftSidebarRef = useRef<SidebarRef>(null!);
	const rightSidebarRef = useRef<SidebarRef>(null!);
	const rootRef = useRef(null);
	const classes = useStyles(props);

	React.useImperativeHandle(ref, () => ({
		rootRef,
		toggleLeftSidebar: () => {
			leftSidebarRef.current.toggleSidebar();
		},
		toggleRightSidebar: () => {
			rightSidebarRef.current.toggleSidebar();
		},
	}));

	return (
		<div className={clsx(classes.root, props.innerScroll && classes.innerScroll)} ref={rootRef}>
			{/* <div className={clsx(classes.header, classes.topBg)} /> */}

			<div className="flex flex-auto flex-col container z-10 h-full">
				{props.header && props.sidebarInner && <FusePageSimpleHeader header={props.header} classes={classes} />}

				<div className={classes.wrapper}>
					{(props.leftSidebarHeader || props.leftSidebarContent) && (
						<FusePageSimpleSidebar
							position="left"
							header={props.leftSidebarHeader}
							content={props.leftSidebarContent}
							variant={props.leftSidebarVariant || 'permanent'}
							innerScroll={props.innerScroll}
							sidebarInner={props.sidebarInner}
							classes={classes}
							ref={leftSidebarRef}
							rootRef={rootRef}
						/>
					)}

					{/* <FuseScrollbars */}
					{/*    className={clsx(classes.contentCardWrapper, props.sidebarInner && classes.contentCardWrapperInnerSidebar)} */}
					{/*    enable={props.innerScroll && props.sidebarInner} */}
					{/* > */}
					<FuseScrollbars
						className={classes.contentWrapper}
						enable={props.innerScroll && !props.sidebarInner}
					>
						{props.header && !props.sidebarInner && (
							<FusePageSimpleHeader header={props.header} classes={classes} />
						)}

						{props.contentToolbar && <div className={classes.toolbar}>{props.contentToolbar}</div>}

						{props.content && (
							<div
								className={clsx(classes.content, 'starter:pl-88 starter:pr-48', {
									'pl-88 pr-48': pageSection.landing,
								})}
							>
								{props.content}
							</div>
						)}
					</FuseScrollbars>
					{/* </FuseScrollbars> */}

					{(props.rightSidebarHeader || props.rightSidebarContent) && (
						<FusePageSimpleSidebar
							position="right"
							header={props.rightSidebarHeader}
							content={props.rightSidebarContent}
							variant={props.rightSidebarVariant || 'permanent'}
							innerScroll={props.innerScroll}
							sidebarInner={props.sidebarInner}
							classes={classes}
							ref={rightSidebarRef}
							rootRef={rootRef}
						/>
					)}
				</div>
			</div>
		</div>
	);
});

export default React.memo(FusePageSimple);
